import React from 'react';

import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import PartialsQuestion from '../../components/Partials/PartialsQuestion';
import MainView from '../../components/service/Extension/MainView';

const TeamRxtension = () => {
  return (
    <Layout
      title="Team Extention Services | Ulam Labs"
      description="We develop software from scratch, but also we can support your development team  by adding more power."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Team extension</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <MainView />
      <PartialsQuestion />
    </Layout>
  );
};

export default TeamRxtension;
